import React, { useEffect, useState } from "react";
import * as Icon from "react-feather";

//@MUI
import {
  Button,
  Checkbox,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";
import {
  CalendarPlus,
  CaretLeft,
  CheckSquare,
  Kanban,
  ListBullets,
  PaintBrushHousehold,
  PencilSimple,
  Table,
  TreeStructure,
  ChartPieSlice,
} from "phosphor-react";
import { useHistory } from "react-router";
import { FilterButton } from "../../CommonComponents/CommonButtons/CommonButtons.Component";
import BreadCrumb from "../../Utilities/BreadCrumb/BreadCrumb.jsx";
import TaskGanttNavBar from "../../Utilities/TaskGantt/TaskGanttNavBar/TaskGanttNavBar.jsx";
import useStyles from "./MyTasksPageTool.styles";

function TaskPageTools(props) {
  const classes = useStyles();
  const history = useHistory();
  const [view, setView] = useState("List");
  //important for the dropdown select for views
  const [isScreenSize, setScreenSize] = useState(window.innerWidth > 1112);
  const [btnActive, setBtnActive] = useState(false);
  const [trackableDetail, setTrackableDetail] = useState({
    name: "Task",
    url: null,
  });
  const updateScreenSize = () => {
    setScreenSize(window.innerWidth > 1112);
  };
  useEffect(() => {
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  });
  useEffect(() => {
    props.onTabChange(view);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);
  useEffect(() => {
    if (props.trackableType === "asset") {
      setTrackableDetail({
        name: "Asset",
        url: `/${props.params.projectId}/assets/`,
      });
    }
    if (props.trackableType === "shot") {
      setTrackableDetail({
        name: "Shot",
        url: `/${props.params.projectId}/sequence/${props.params.sid}/shots/`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const empty = Object.values(props.filtersForTask).every(
      (val) => val === ""
    );
    setBtnActive(!empty);
  }, [props.filtersForTask]);

  return (
    <div>
      {props.trackableType !== "task" ? <BreadCrumb /> : ""}
      <div className={classes.root}>
        {props.selectTasksActive ? (
          <div>
            {view === "List" &&
              (props.selectTasksActive ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <Button
                    startIcon={<CaretLeft />}
                    onClick={() => {
                      props.clearSelectedTask();
                      props.setSelectTasksActive(false);
                    }}
                    className={classes.backButton}
                  >
                    Back
                  </Button>{" "}
                  <Button
                    startIcon={<PencilSimple />}
                    onClick={props.openTaskUpdateModal}
                    disabled={props.selectedTaskCount === 0}
                    className={
                      props.selectedTaskCount === 0
                        ? classes.disabledButton
                        : classes.activeButton
                    }
                  >
                    Update Tasks
                  </Button>
                  <Button
                    startIcon={<CalendarPlus />}
                    onClick={props.handleOpenTaskBulkUpdateModal}
                    disabled={props.selectedTaskCount === 0}
                    className={
                      props.selectedTaskCount === 0
                        ? classes.disabledButton
                        : classes.activeButton
                    }
                  >
                    Update Date & Score
                  </Button>
                  <Button
                    startIcon={<PaintBrushHousehold />}
                    disabled={props.selectedTaskCount === 0}
                    className={
                      props.selectedTaskCount === 0
                        ? classes.disabledButton
                        : classes.activeButton
                    }
                    onClick={() => {
                      props.clearSelectedTask();
                    }}
                  >
                    Clear Selection
                  </Button>
                  {/*  <Button
                    startIcon={<Trash />}
                    onClick={props.handleOpenTaskBulkUpdateModal}
                    disabled={props.selectedTaskCount === 0}
                    className={
                      props.selectedTaskCount === 0
                        ? classes.disabledButton
                        : classes.activeDeleteButton
                    }
                  >
                    Delete Selection
                  </Button> */}
                </div>
              ) : (
                ""
              ))}
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <h1
              className={classes.title}
              onClick={() => {
                if (trackableDetail.url) {
                  history.push(trackableDetail.url);
                }
              }}
            >
              {trackableDetail.name}
            </h1>
            <div>
              {isScreenSize ? (
                <Tabs
                  value={view}
                  onChange={(event, value) => {
                    setView(value);
                  }}
                  style={{ marginLeft: "30px", minHeight: "50px" }}
                >
                  {/* <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ListBullets
                      style={{
                        margin: "4px 12px",
                        height: "22px",
                        width: "22px",
                      }}
                    />
                    <span>List View</span>
                  </div>
                }
                value={"List"}
                style={{
                  width: "400px",
                  marginLeft: "30px",
                  minHeight: "50px",
                }}
              /> */}
                  <Tab
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ListBullets
                          style={{
                            margin: "4px 12px",
                            height: "22px",
                            width: "22px",
                          }}
                        />
                        <span>List View</span>
                      </div>
                    }
                    value={"List"}
                    style={{
                      minWidth: "65px",
                      fontSize: "14px",
                      minHeight: "30px",
                      padding: "2px",
                    }}
                  />
                  <Tab
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <TreeStructure
                          style={{
                            margin: "4px 12px",
                            height: "22px",
                            width: "22px",
                          }}
                        />
                        <span>Gantt View</span>
                      </div>
                    }
                    value={"Gantt"}
                    style={{
                      minWidth: "65px",
                      fontSize: "14px",
                      minHeight: "30px",
                      padding: "2px",
                    }}
                  />
                  <Tab
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Table
                          style={{
                            margin: "4px 12px",
                            height: "22px",
                            width: "22px",
                          }}
                        />
                        <span>Table View</span>
                      </div>
                    }
                    value={"Table"}
                    style={{
                      minWidth: "46px",
                      fontSize: "14px",
                      padding: "2px",
                    }}
                  />
                  <Tab
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Kanban
                          style={{
                            margin: "4px 12px",
                            height: "22px",
                            width: "22px",
                          }}
                        />
                        <span>Kanban View</span>
                      </div>
                    }
                    value={"Kanban"}
                    style={{
                      minWidth: "46px",
                      fontSize: "14px",
                      padding: "2px",
                    }}
                  />
                  <Tab
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ChartPieSlice
                          style={{
                            margin: "4px 12px",
                            height: "22px",
                            width: "22px",
                          }}
                        />
                        <span>Analytics View</span>
                      </div>
                    }
                    value={"analytics"}
                    style={{
                      minWidth: "46px",
                      fontSize: "14px",
                      padding: "2px",
                    }}
                  />
                </Tabs>
              ) : (
                <Select
                  style={{
                    marginLeft: "30px",
                    minHeight: "50px",
                  }}
                  autoWidth={true}
                  disableUnderline={true}
                  value={view}
                  label={view}
                  onChange={(event) => setView(event.target.value)}
                >
                  <MenuItem className={classes.menuitem} value={"List"}>
                    List View
                  </MenuItem>
                  <MenuItem className={classes.menuitem} value={"Gantt"}>
                    Gantt View
                  </MenuItem>
                  <MenuItem className={classes.menuitem} value={"Table"}>
                    Table View
                  </MenuItem>
                  <MenuItem className={classes.menuitem} value={"Kanban"}>
                    Kanban View
                  </MenuItem>
                </Select>
              )}
            </div>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {view === "List" &&
            (!props.selectTasksActive ? (
              <Button
                startIcon={<CheckSquare />}
                style={{ minWidth: "0px", padding: "4px 7px" }}
                onClick={() => props.setSelectTasksActive(true)}
              >
                <Typography className={classes.checkBoxText}>
                  Multi-Select
                </Typography>
              </Button>
            ) : (
              ""
            ))}
          <div>
            {view === "Gantt" ? (
              <TaskGanttNavBar
                onViewChange={props.onGanttViewModeChange}
                onSave={() => props.externalSaveEvent.triggerSaveEvent()}
                isDateChanged={props.externalSaveEvent?.isDateChanged}
              />
            ) : (
              <>
                {props.showMyTaskCheckBox && !props.selectTasksActive ? (
                  <div style={{ width: "200px" }}>
                    <Checkbox
                      checked={props.myTaskCheckBoxState}
                      onChange={props.onCheckBoxClick}
                    />
                    <span className={classes.checkBoxText}>
                      Show only my tasks
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
          {!props.selectTasksActive ? (
            <Button
              style={{ padding: "8px 4px", minWidth: "0px" }}
              onClick={() => props.updateRefreshCounter()}
            >
              <Icon.RotateCw />
            </Button>
          ) : (
            ""
          )}
          <FilterButton
            btnActive={btnActive}
            openFilterModal={props.openFilterModal}
          />
          {!props.selectTasksActive ? (
            <Button
              color="secondary"
              size="small"
              variant="contained"
              className={classes.taskPageButton}
              onClick={props.handleCreateTaskOptionModalState}
              // disabled={props.trackableType === "task" ? true : false}
            >
              <Icon.Plus className={classes.plusIcon} />
              <p className={classes.text}>New Task</p>
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* <hr className={classes.hrElement} /> */}
    </div>
  );
}

export default TaskPageTools;
